import React from "react";
import { Container } from "reactstrap";
import styles from "./PoliticaPrivacidade.module.css";

const PoliticaPrivacidade = () => {
    return (
        <Container>

            <section className={styles.section}>
                <h2 className={styles.sectionTitlePrimary}>A sua privacidade é nossa prioridade</h2>
                <p className={styles.sectionContent}>
                    No GuardAi, respeitamos a sua privacidade e estamos comprometidos em proteger quaisquer informações pessoais coletadas através de nosso aplicativo ou site. Coletamos informações apenas quando necessário para fornecer nossos serviços de forma eficiente e segura. Informamos previamente por que estamos coletando suas informações e como elas serão utilizadas.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Informações que coletamos</h2>
                <p className={styles.sectionContent}>
                    Coletamos informações como nome, CPF, telefone, email, e dados de cadastro relacionados ao condomínio e unidade onde o serviço será prestado. Esses dados são essenciais para criar sua conta, gerenciar acessos e entregar funcionalidades do nosso sistema.
                </p>
                <p className={styles.sectionContent}>
                    Além disso, podemos coletar informações sobre seu dispositivo, como modelo, sistema operacional, e registros de uso do aplicativo para melhorias contínuas e suporte técnico.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Como utilizamos suas informações</h2>
                <ul className={styles.list}>
                    <li>Identificar e autenticar usuários;</li>
                    <li>Gerenciar acesso aos serviços do GuardAi;</li>
                    <li>Comunicar informações importantes sobre nossos serviços;</li>
                    <li>Garantir a segurança de dados e acessos;</li>
                    <li>Fornecer suporte técnico e operacional;</li>
                    <li>Envio de notificações de encomendas recebidas.</li>
                </ul>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Proteção dos seus dados</h2>
                <p className={styles.sectionContent}>
                    Adotamos medidas tecnológicas e organizacionais adequadas para proteger seus dados contra acessos não autorizados, perda ou alteração. Apenas retemos informações pelo tempo necessário para atender às finalidades descritas ou conforme exigido por lei.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Compartilhamento de informações</h2>
                <p className={styles.sectionContent}>
                    Não compartilhamos suas informações pessoais com terceiros, exceto quando exigido por lei ou para fornecer os serviços contratados, como integrações específicas com dispositivos IoT ou sistemas de condomínios. Em todos os casos, garantimos que os terceiros envolvidos mantenham seus dados seguros e em conformidade com esta política.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Cookies e rastreamento</h2>
                <p className={styles.sectionContent}>
                    Utilizamos cookies e tecnologias de rastreamento para melhorar sua experiência no aplicativo e no site. Isso inclui funcionalidades como manter sua sessão ativa, oferecer suporte técnico personalizado e analisar padrões de uso para melhorias. Você pode desativar cookies nas configurações do seu navegador, mas isso pode impactar o uso de algumas funcionalidades.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Compromisso do Usuário</h2>
                <p className={styles.sectionContent}>
                    O usuário se compromete a:
                </p>
                <ul className={styles.list}>
                    <li>Fornecer informações precisas e atualizadas durante o cadastro;</li>
                    <li>Utilizar o aplicativo de maneira ética e dentro das normas legais e de boa-fé;</li>
                    <li>Não disseminar conteúdos ilícitos, maliciosos ou que violem os direitos de outros usuários ou terceiros;</li>
                    <li>Proteger suas credenciais de acesso e informar-nos imediatamente em caso de uso não autorizado.</li>
                </ul>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Links externos</h2>
                <p className={styles.sectionContent}>
                    Nosso aplicativo ou site pode conter links para páginas externas. Não temos controle sobre as práticas de privacidade desses sites e recomendamos que você leia suas políticas de privacidade antes de fornecer quaisquer informações.
                </p>
            </section>

            <section className={styles.section}>
                <h2 className={styles.sectionTitleSecondary}>Alterações nesta política</h2>
                <p className={styles.sectionContent}>
                    Esta política pode ser atualizada periodicamente para refletir mudanças na legislação ou em nossos serviços. Recomendamos que você revise este documento regularmente.
                </p>
            </section>

            <p className={styles.sectionFooter}>Esta política é efetiva a partir de 6 de abril de 2024.</p>
        </Container>
    );
};

export default PoliticaPrivacidade;
